const url = "http://members.kfm666666.net" // 后台正式接口域名
const local_url = "http://members.kfm666666.net/" // 线上测试域名 
const APPID = 'wxd106ba80a93be47e' // 线上APPID




// const url = "http://project1.kfm666666.net" // 后台测试接口域名
// const local_url = "http://sxl.nat300.top" // 本机测试域名
// const APPID = 'wx157f6bc672aa5e4b' // 测试APPID


export default{
  url,
  local_url,
  APPID,
}
